<script>
  import { onMount } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recsStore = getGroupStore('recsStore');
  import ComponentEvents from '@utils/component-events';
  import ScrollSpy from '@utils/scrollspy';

  import jQuery from 'jquery';

  let group = groupStore;
  let sections = sectionsStore;
  let recs = recsStore;
  let currentSection;
  let unsubCurrentSection;
  let showModal = false;
  let showSectionBar = false;
  let scrollUpdatesEnabled = true;
  let firstSectionTop;

  let close = function () {
    showModal = false;
  };

  let show = function () {
    showModal = true;
  };

  let toggleSectionMenu = function () {
    if (showModal) {
      close();
    } else {
      show();
    }
  };

  let scrollToSection = function (section) {
    let elem = jQuery(`#ui-section-${section.id}`).parent().find('.ui-section-name');

    let sectionOffset = 20 - 134 - elem.height() - (jQuery('.m-current-section').height() || 0) - 39;

    jQuery('.ui-section').css('opacity', 0);
    let maxIntervals = 50;
    let matchCount = 0;
    let intervals = 0;
    let sp = jQuery(window).scrollTop();

    let int = setInterval(function () {
      jQuery(window).scrollTop(elem.offset().top + sectionOffset);
      let newSP = jQuery(window).scrollTop();
      if (intervals >= maxIntervals) {
        return clearInterval(int);
      }
      if (newSP != sp) {
        sp = newSP;
      } else {
        jQuery('.ui-section').css('opacity', 1);
        matchCount += 1;
        if (matchCount >= 5) {
          clearInterval(int);
        }
      }
      intervals += 1;
    }, 50);
  };

  let maxTop = function () {
    if (firstSectionTop) {
      return firstSectionTop;
    } else {
      try {
        firstSectionTop = jQuery(jQuery('.ui-section')[0]).position().top - 45;
      } catch {
        firstSectionTop = 0;
      }
      return firstSectionTop;
    }
  };

  let showAndHideSectionBar = function (top) {
    const oldValue = showSectionBar;

    if (top >= maxTop()) {
      showSectionBar = true;
    } else {
      showSectionBar = false;
    }

    if (oldValue !== showSectionBar) {
      ComponentEvents.trigger('mobile-show-fixed-section-bar', {
        showSectionBar,
      });
    }
  };

  let setMarginTopForModal = function (node) {
    var h = (jQuery('.m-current-section').height() + 25 || 0) + 60;
    var cont = jQuery(node).closest('.modal__container');
    var bodyHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    cont.attr(
      'style',
      `${cont.attr('style')}; margin-top: ${h}px !important; min-height: ${
        bodyHeight - h - (jQuery('.bottom-bar-visible').length === 0 ? 0 : 65) + 1
      }px;`
    );
  };

  let setCurrentSection = function (section) {
    if (unsubCurrentSection) {
      unsubCurrentSection();
    }

    currentSection = section;

    if (currentSection) {
      unsubCurrentSection = currentSection.subscribe((x) => (currentSection = x));
    }
  };

  let unsubSetCurrentSection = ComponentEvents.on('mobile-set-current-section', async function (data) {
    if (data && data.section) {
      scrollUpdatesEnabled = false;
      setCurrentSection(data.section);
      setTimeout(function () {
        scrollUpdatesEnabled = true;
      }, 500);
    }
  });

  let unsubScrollToSection = ComponentEvents.on('mobile-scroll-to-section', scrollToSection);

  let removeScrollSpy;

  const setupScrollSpy = () => {
    ScrollSpy.setup('column-current-section');
    removeScrollSpy = ScrollSpy.on('column-current-section', (data) => {
      ComponentEvents.trigger('current-section', data);
    });
  };

  let unsubCurrentSectionComponentEvent;
  const setupCurrentSectionComponentEvent = () => {
    unsubCurrentSectionComponentEvent = ComponentEvents.on('current-section', async (data) => {
      if (scrollUpdatesEnabled && data && data.section) {
        setCurrentSection(data.section);
      }
    });
  };

  onMount(() => {
    let unsubGroup = group.subscribe((x) => (group = x));
    let unsubSections = sectionsStore.subscribe((x) => (sections = x));
    let unsubRecs = recsStore.subscribe((x) => (recs = x));

    setupScrollSpy();
    setupCurrentSectionComponentEvent();
    jQuery(window).scroll(function () {
      var top = jQuery(document).scrollTop();
      showAndHideSectionBar(top);
    });

    return () => {
      unsubGroup();
      unsubSections();
      unsubRecs();
      removeScrollSpy();
      unsubSetCurrentSection();
      unsubScrollToSection();
      unsubCurrentSectionComponentEvent();

      if (unsubCurrentSection) {
        unsubCurrentSection();
      }
    };
  });
</script>

<style style="text/scss" lang="scss">
  .m-current-section {
    display: flex;
    top: 51px;
    justify-content: space-between;
    background: white;
    position: fixed;
    width: 100%;
    z-index: 4;
    left: 0;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 17px;
    padding-bottom: 20px;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
  }

  .section-name {
    font-size: 15px;
    flex: 1;
    opacity: 0.5;
    word-break: break-word;
  }

  .section-recobjects-count {
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    margin-left: 10px;
    flex-shrink: 0;
    min-width: 24px;
    min-height: 24px;
    color: black;
    opacity: 0.5;
  }

  .section-active {
    align-items: center;

    .section-name {
      opacity: 1 !important;
      font-weight: 500 !important;
    }

    .section-recobjects-count {
      background: #a893f9 !important;
      color: white !important;
      opacity: 1 !important;
    }
  }

  * :global(.modal__overlay) {
    background: unset !important;
  }

  :global(.bottom-bar-visible) :global(.svelte-section-bar-modal) {
    bottom: 60px !important;
  }
</style>

{#if showSectionBar && currentSection}
  {#if currentSection}
    <div class="m-current-section" on:click={toggleSectionMenu}>
      <div style="flex-shrink: 0; width: calc(100% - 90px)">
        <div style="font-size: 13px; opacity: 0.5;">{group.name}</div>
        <div style="font-size: 15px; font-weight: 500; padding-top: 4px; word-break: break-word;">
          {currentSection.name}
        </div>
      </div>
      <div style="display: flex; align-items: center; flex-shrink: 0">
        {#if !showModal}
          <img src="/images/mobile/section-bar-up-arrow.svg" />
        {/if}
      </div>
    </div>
  {/if}

  <div class="svelte-modal svelte-section-bar-modal">
    <Modal
      style="margin: 0px !important; border-radius: 0px !important;
    background-image: -webkit-linear-gradient(top, #eee 0%, #fff 100px);
    background-image: -moz-linear-gradient(top, #eee 0%, #fff 100px);
    background-image: linear-gradient(top, #eee 0%, #fff 100px); padding-left:
    30px !important; padding-right: 30px !important; min-width: 100%;"
      mobile={true}
      bind:show={showModal}
      showCloseButton={false}
      fadeInDuration={200}>
      <div slot="content" use:setMarginTopForModal>
        <div
          style="position: absolute; top: 0px; left: 0px; right: 0px; height:
        70px; z-index: 2; background: transparent;"
          on:click={toggleSectionMenu} />
        <div style="display: flex; align-items: center; cursor: pointer;" on:click={toggleSectionMenu}>
          <div style="flex: 1; font-size: 13px; line-height: 16px; font-weight: 500">Sections</div>
          <div style="flex-shrink: 0; margin-right: 6px;">
            <img src="/images/mobile/section-bar-down-arrow.svg" />
          </div>
        </div>

        <div>
          {#each sections.sortBy((x) => x.position) as section}
            <div
              style="display: flex; margin-top: 22px; cursor: pointer;"
              on:click|preventDefault|stopPropagation={() => {
                showModal = false;
                scrollToSection(section);
                ComponentEvents.trigger('mobile-set-current-section', {
                  section: section,
                });
              }}
              class:section-active={currentSection && currentSection.id == section.id}>
              <div class="section-name">{section.name}</div>
              <div class="section-recobjects-count">
                {[...new Set(recs.where({ section_id: section.id }).map((x) => x.rec_object_id))].length}
              </div>
            </div>
          {/each}
        </div>
      </div>
      <div style="height: 100px">&nbsp;</div>
    </Modal>
  </div>
{/if}
